import React from "react";
import "../styles/TotalesEncabezadoHistoricoContenedor.css";

const TotalesEncabezadoHistoricoContenedor = ({ Contenedor, previewData }) => {
    // Aplanar los datos agrupados para los cálculos
    const allProducts = previewData.flatMap(pedido => pedido.productos);

    const sumaTotalCajas = allProducts.reduce((acc, row) => acc + (parseFloat(row.CantCajas) || 0), 0);
    const sumaCMBTotal = allProducts.reduce((acc, row) => acc + (parseFloat(row.CBMTotal) || 0), 0);
    const sumaPesoBruto = allProducts.reduce((acc, row) => acc + (parseFloat(row.PesoBruto) || 0), 0);
    const tiposMciaTotales = allProducts.reduce((acc, row) => {
        const tipo = row.TipoMcia || 'Sin Tipo';
        acc[tipo] = (acc[tipo] || 0) + 1;
        return acc;
    }, {});

    const tiposMciaArray = Object.entries(tiposMciaTotales).map(
        ([tipo, cantidad]) => `${tipo}: ${cantidad}`
    );

    return (
        <div className="contenedor-details-horizontal">
            <div className="contenedor-info">
                <strong>ID Contenedor:</strong> {Contenedor?.IdContenedor || 'No disponible'}
            </div>
            <div className="contenedor-info">
                <strong>Número de Contenedor:</strong> {Contenedor?.sNroContenedor || 'No disponible'}
            </div>
            <div className="contenedor-info">
                <strong>Estado:</strong> {Contenedor?.sNombreEstadoContenedor || 'No disponible'}
            </div>
            <div className="contenedor-info">
                <strong>Ítems Totales:</strong> {allProducts.length}
            </div>
            <div className="contenedor-info">
                <strong>Cajas Totales:</strong> {sumaTotalCajas.toFixed(0)}
            </div>
            <div className="contenedor-info">
                <strong>CBM Total:</strong> {sumaCMBTotal.toFixed(2)}
            </div>
            <div className="contenedor-info">
                <strong>Peso Bruto Total:</strong> {sumaPesoBruto.toFixed(2)}
            </div>
            <div className="contenedor-info tipos-mercancia-container">
                <strong>Tipos de Mercancía:</strong>
                <ul className="tipos-mcia-list">
                    {tiposMciaArray.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TotalesEncabezadoHistoricoContenedor;